import { useSupporter } from '../state/SupporterContext';
import { Button } from './Button';

/** Voluntary Ko-fi / Buy Me a Coffee tip link. Hidden if no tip URL is configured. */
export function TipButton({ size = 'sm' }: { size?: 'sm' | 'md' | 'lg' }) {
  const { canTip, openTip } = useSupporter();
  if (!canTip) return null;
  return (
    <Button variant="ghost" size={size} onClick={openTip}>
      ☕ Tip jar
    </Button>
  );
}
